import { configureStore } from "@reduxjs/toolkit";
import authSliceReducer from "./authSlice";
import publicSliceReducer from "./publicSlice";

const store = configureStore({ reducer: { auth: authSliceReducer, public: publicSliceReducer } });

export default store;